export const PaperType = {
  None : 0,
  Blank: 1,
  // PaymentSlip_Bottom: 2,
  PaymentSlip_Bottom_Right: 2,
  Blank_PaymentSlipBottom: 3,
  PZU: 4,
  Blank_PZU: 5,
  Blank_PaymentSLipBottom_PZU: 7,
  PaymentSlip_Bottom_Left : 8,
  // Blank_PZU = Blank | PZU,                                                            // 00101 -  5
  // Blank_PaymentSlipBottomRight = Blank | PaymentSlip_Bottom_Right,                    // 00011 -  3
  // Blank_PaymentSlipBottomLeft = Blank | PaymentSlip_Bottom_Left,                      // 01001 -  9
  //
  // Blank_PaymentSlipBottomRight_PZU = Blank | PaymentSlip_Bottom_Right | PZU,          // 00111 -  7
  // Blank_PaymentSlipBottomLeft_PZU = Blank | PaymentSlip_Bottom_Left | PZU,            // 01101 -  13
}
